import { Zap } from 'lucide-react';
import { Button, Img, Modal } from '../Common';
import { useTranslation } from '../../hooks/useTranslation';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectActiveSubscription } from '../../store/slices/active-subscription.slice';
import { useNavigate } from 'react-router-dom';
import { shouldDisplayTrialUI, calculateTrialDaysRemaining } from '../../util/pricingPlanHelper';

const SubscriptionReminder = () => {
    const { t } = useTranslation();
    const [isUpgradeModalVisible, setIsUpgradeModalVisible] = useState(false);
    const activeSubscription = useSelector(selectActiveSubscription);
    const navigate = useNavigate();

    const handleSwitchPlans = () => {
        setIsUpgradeModalVisible(false);
    };

    if (!shouldDisplayTrialUI(activeSubscription)) return null;

    const daysRemaining = calculateTrialDaysRemaining(activeSubscription);

    const getTrialMessage = () => {
        if (daysRemaining === 0) return t('billing.billingTrialEndsToday');

        const message = t('billing.billingReminder');
        const [before, after] = message.split('{{daysLeft}}');
        return (
            <>
                {before}
                <strong>
                    {daysRemaining} {after}
                </strong>
            </>
        );
    };

    return (
        <>
            <div className="billing-reminder">
                <p className="paragraph-4">{getTrialMessage()}</p>
                <Button
                    variant="contained"
                    iconRightNode={<Zap size={12} />}
                    text={t('billing.upgradeButton')}
                    onClick={() => navigate('/subscription')}
                />
            </div>
            <Modal isVisible={isUpgradeModalVisible} closeModal={() => setIsUpgradeModalVisible(false)}>
                <div className="upgrade-modal">
                    <button type="button" className="upgrade-modal__close" onClick={() => setIsUpgradeModalVisible(false)} aria-label="Close modal">
                        <Img src="/svg/x-button.svg" alt="" width={12} height={12} />
                    </button>

                    <div className="upgrade-modal__body">
                        <h1 className="upgrade-modal__title">{t('billing.upgradeModalTitle')}</h1>
                        <p className="paragraph-3">{t('billing.upgradeModalText', { fromPlan: 'Free', toPlan: 'Standard' })}</p>
                        <div className="upgrade-modal__buttons">
                            <Button onClick={() => setIsUpgradeModalVisible(false)} text="Cancel" variant="text" />
                            <Button onClick={handleSwitchPlans} text="Switch Plans" variant="contained" />
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default SubscriptionReminder;
